import { useEffect } from 'react';
import useFetchData from '../../hooks/useFetchData';
import { useSearchParams } from 'react-router-dom';

const PaymentFailPage = () => {
  const [searchParams] = useSearchParams();
  const { data } = useFetchData(
    `payment/payment_fail${window.location.search}`
  );
  const errMsg = searchParams.get('errMsg');

  useEffect(() => {
    if (data && data.affected === 1) {
      // alert('תשלום נכשל')
      window.top.location.reload();
    }
  }, [data]);

  return (
    <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
      {errMsg || 'התשלום נכשל'}
    </div>
  );
};

export default PaymentFailPage;
